import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ShoppingBagIcon, MessageCircleIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useStore } from '../contexts/StoreContext';
import { salon } from '../data/content';
const nav = [{
  to: '/behandelingen',
  label: 'Behandelingen'
}, {
  to: '/webshop',
  label: 'Webshop'
}, {
  to: '/journal',
  label: 'Blog & Podcast'
}, {
  to: '/over-ons',
  label: 'Over ons'
}];
const announcements = ['Gratis verzending vanaf € 100', '100% vegan & dierproefvrij', 'Gratis kennismaking: Shelfie Time'];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    pathname
  } = useLocation();
  const {
    count,
    openCart,
    openBooking
  } = useStore();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="sticky top-0 z-50" data-id="element-178" data-mp="2rkyjyz5vtzsu">
      <div className="bg-ink text-shell" data-id="element-179" data-mp="2ro47i9yv4tmg">
        <div className="mx-auto flex max-w-content items-center justify-center gap-8 px-6 py-2 lg:justify-between lg:px-10" data-id="element-180" data-mp="2mlvghj5jw1mz">
          <ul className="flex items-center gap-8 text-[11px] tracking-wide text-shell/75" data-id="element-181" data-mp="2hp4yure3kxzg">
            {announcements.map((a, i) => <li key={a} className={i === 0 ? '' : 'hidden sm:block'} data-id="element-182" data-mp="3ac96730nxoee" data-mpi={i}>
                {a}
              </li>)}
          </ul>
          <a href={salon.whatsapp} className="hidden items-center gap-2 text-[11px] tracking-wide text-shell/75 transition-colors duration-150 ease-soft hover:text-shell lg:flex" data-id="element-183" data-mp="35khgeupbzmpb">
            <MessageCircleIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-184" data-mp="1y0leh4du1ws" />
            Persoonlijk advies via WhatsApp
          </a>
        </div>
      </div>

      <header className={`border-b transition-colors duration-200 ease-soft ${scrolled ? 'border-line bg-shell/95 backdrop-blur-md' : 'border-transparent bg-sand'}`} data-id="element-185" data-mp="1rdtcbws5s14w">
        <div className={`mx-auto flex max-w-content items-center justify-between gap-6 px-6 transition-[height] duration-200 ease-soft lg:px-10 ${scrolled ? 'h-[68px]' : 'h-[84px]'}`} data-id="element-186" data-mp="1ho9vsxrx4jd7">
          <Logo className={scrolled ? 'h-9' : 'h-11'} data-id="element-187" data-mp="18maee4czrd9q" />

          <nav aria-label="Hoofdnavigatie" className="hidden items-center gap-8 lg:flex" data-id="element-188" data-mp="1cof5owfyvxt7">
            {nav.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `group relative whitespace-nowrap py-1 text-[13px] tracking-wide transition-colors duration-150 ease-soft hover:text-ink ${isActive ? 'text-ink' : 'text-muted'}`} data-id="element-189" data-mp="ypp536txvg03">
                {({
              isActive
            }) => <>
                    {item.label}
                    <span className={`absolute -bottom-0.5 left-0 h-px bg-clay transition-[width] duration-200 ease-soft ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-190" data-mp="hftpub3iq55j" />
                  </>}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-2 lg:flex" data-id="element-191" data-mp="153b9tkgjjyxy">
            <button type="button" onClick={openCart} className="relative flex items-center gap-2 rounded-full border border-line px-4 py-2.5 text-[13px] text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-192" data-mp="106ukwo1ipgjt">
              <ShoppingBagIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-193" data-mp="3guf6w4jlk9qx" />
              Mand
              {count > 0 && <span className="ml-0.5 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-clay px-1 text-[11px] text-shell" data-id="element-194" data-mp="3bwdmngafq4dv">
                  {count}
                </span>}
            </button>
            <button type="button" onClick={() => openBooking()} className="whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-[13px] text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-195" data-mp="27w716qdy1g8c">
              Boek een afspraak
            </button>
          </div>

          <div className="flex items-center gap-1 lg:hidden" data-id="element-196" data-mp="1k6cpic5d1xpo">
            <button type="button" onClick={openCart} aria-label="Winkelmand openen" className="relative p-2 text-ink" data-id="element-197" data-mp="1p7sak47jg482">
              <ShoppingBagIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-198" data-mp="1y0ds5gzfo4vb" />
              {count > 0 && <span className="absolute right-0 top-0 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-clay px-1 text-[10px] text-shell" data-id="element-199" data-mp="11gwolnprk38q">
                  {count}
                </span>}
            </button>
            <button type="button" aria-label={open ? 'Menu sluiten' : 'Menu openen'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="-mr-2 p-2 text-ink" data-id="element-200" data-mp="xxebgdpjzcvl">
              {open ? <XIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-201" data-mp="k23k3aaip9vz" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-202" data-mp="f2h4iu77vhk0" />}
            </button>
          </div>
        </div>

        {open && <div className="border-t border-line bg-shell lg:hidden" data-id="element-203" data-mp="5atjbb196wqz">
            <nav aria-label="Mobiele navigatie" className="mx-auto max-w-content px-6 py-6" data-id="element-204" data-mp="590em1a7amlm">
              <ul className="divide-y divide-line border-y border-line" data-id="element-205" data-mp="17esrqfouxza">
                {nav.map(item => <li key={item.to} data-id="element-206" data-mp="3shn89uwc0246">
                    <NavLink to={item.to} className="block py-4 font-display text-2xl text-ink" data-id="element-207" data-mp="3ngg2209u7azm">
                      {item.label}
                    </NavLink>
                  </li>)}
              </ul>
              <button type="button" onClick={() => {
            setOpen(false);
            openBooking();
          }} className="mt-6 w-full rounded-full bg-ink py-3.5 text-sm text-shell" data-id="element-208" data-mp="3isyf4jehwofa">
                Boek een afspraak
              </button>
              <a href={salon.whatsapp} className="mt-2 flex w-full items-center justify-center gap-2 rounded-full border border-line py-3.5 text-sm text-ink" data-id="element-209" data-mp="gacym8zp71d">
                <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-210" data-mp="3mrxsmsealtic" />
                Advies via WhatsApp
              </a>
            </nav>
          </div>}
      </header>
    </div>;
}